import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Shared aimhomoeopathy project: this site only uses Firestore ajhm_content and Storage AJHM/uploads
// (see firestore.rules / storage.rules). Analytics is left off so other apps' data is untouched.
const firebaseConfig = {
  apiKey: 'AIzaSyCgkeF255pwJ5nxjaJBGwICXnbIUBerJMc',
  authDomain: 'aimhomoeopathy.firebaseapp.com',
  databaseURL: 'https://aimhomoeopathy.firebaseio.com',
  projectId: 'aimhomoeopathy',
  storageBucket: 'aimhomoeopathy.appspot.com',
  messagingSenderId: '249482035848',
  appId: '1:249482035848:web:dead36b9d1f5e46531953d',
  measurementId: 'G-8WRLHXM2RR',
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const storage = getStorage(app);
